import actionTypes from '../actionTypes';

const initialState = {
  type: null,
  msg: null,
  id: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ALERT_HIDE:
      return { ...state, msg: null };

    case actionTypes.ALERT_SHOW:
      return { ...state, ...action.payload, id: state.id + 1 };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/alert.js